/**
 * The portal — the module picker, and the first screen after a login.
 *
 * Module NAMES are not here; they live in ./modules.js, keyed by module id, because the nav strip
 * draws the same names and two copies of "Fleet Management" is how the two surfaces drift.
 *
 * Anything with a number in it is a FUNCTION. "3 reports awaiting approval" is a count, and neither
 * the number's position nor the plural survives translation intact.
 */
export default {
  dashboard: 'Dashboard',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  refresh: 'Refresh',
  user: 'User',
  view: 'View',

  // ── profile card ──────────────────────────────────────────────────────────────────────────────
  editProfile: 'Edit Profile',
  adminPanel: 'Admin Panel',

  // ── notifications panel ───────────────────────────────────────────────────────────────────────
  notifications: 'Notifications',
  markAllRead: 'Mark all read',
  noNewNotifications: 'No new notifications',
  notificationsHint: 'Timekeeping, bid request, and system alerts will appear here.',
  timekeepingNotification: 'Timekeeping notification',

  // ── section headings ──────────────────────────────────────────────────────────────────────────
  kpiSummary: 'Summary',
  quickActions: 'Quick Actions',
  modules: 'Modules',
  noModules: 'No modules available',
  noModulesHelp: 'Contact your administrator to be granted access.',
  soon: 'Soon',
  comingSoon: (name) => `${name} is coming soon!`,

  // ── a module whose backend is not answering ───────────────────────────────────────────────────
  serviceOffline: 'Service offline',
  serviceOfflineHelp: 'Start the backend to load data',
  // ── a module that answered, and the answer was no ─────────────────────────────────────────────
  accessRefused: 'Your account cannot see this',
  accessRefusedHelp: 'Ask an administrator if you need it.',

  // ── timekeeping widget ────────────────────────────────────────────────────────────────────────
  previousWeek: 'Previous week',
  nextWeek: 'Next week',
  thisWeek: 'This week',
  lastWeek: 'Last week',
  reportsCreated: 'Reports created',
  awaitingApproval: 'Awaiting approval',
  crewHours: 'Crew hrs',
  regularHours: 'Regular hrs',
  overtimeHours: 'Overtime hrs',

  // ── projects / bids / hr / crm / users widgets ────────────────────────────────────────────────
  activeProjects: 'Active projects',
  totalProjects: 'Total projects',
  bidRequests: 'Bid requests',
  totalRequests: 'Total requests',
  pending: 'Pending',
  assigned: 'Assigned',
  completed: 'Completed',
  pipelineValue: 'Pipeline value',
  awardedValue: 'Awarded value',
  activeBids: 'Active bids',
  winRate: 'Win rate',
  activeEmployees: 'Active employees',
  totalRecords: 'Total records',
  totalClients: 'Total clients',
  activeClients: 'Active clients',
  systemUsers: 'System Users',
  activeAccounts: 'Active accounts',
  totalRegistered: 'Total registered',

  // ── quick actions ─────────────────────────────────────────────────────────────────────────────
  qaTimekeeping: 'Submit Timesheet',
  qaBidRequest: 'New Bid Request',
  qaBidWorkup: 'Open Bid Workup',
  qaProjects: 'View Projects',
  qaHr: 'HR Dashboard',
  qaCrm: 'CRM Dashboard',
  qaDocuments: 'Document Control',
  qaFleet: 'Fleet Dashboard',
  qaFinance: 'Finance',
}
